<template>
  <div>
    <!-- Start of Filter Section -->
    <b-row align-v="center" class="py-0 my-0">
      <b-col :cols="columnWidth" v-for="(item, index) in filters">
        <!-- Selection (Non API) -->
        <FITSelect :disabled="item.disabled" v-if="item.type === 'select' && item.options" :label="item.label" :width="8" v-model="form[item.key]" :options="item.options"></FITSelect>
        <!-- Selection (API), same options with other key -->
        <FITSelect :disabled="item.disabled" v-else-if="item.type === 'select' && item.optionsKey" :label="item.label" :width="8" v-model="form[item.key]" :options="getTranslatedArray($i18n.locale, vuexModule, item.optionsKey, item.haveAll)"></FITSelect>
        <!-- Selection (API)-->
        <FITSelect :disabled="item.disabled" v-else-if="item.type === 'select'" :label="item.label" :width="8" v-model="form[item.key]" :options="getTranslatedArray($i18n.locale, vuexModule, item.key, item.haveAll)"></FITSelect>
        <!-- Date Picker -->
        <FITDatePicker v-else-if="item.type === 'datetime'" v-model="form[item.key]" :width="8" :label="item.label" :placeholder="item.label"></FITDatePicker>
        <FITCheckbox v-else-if="item.type === 'checkbox'" :label="item.label" trueString="1" falseString="0" v-model="form[item.key]"></FITCheckbox>
        <b-row v-else-if="item.type === 'number'">
          <b-col cols="4">
            <label>{{item.label}}</label>
          </b-col>
          <b-col cols="8">
            <b-form-input type="number" class="FITInput" @change="onChangeInputFilters($event,item.key,500)"></b-form-input>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="auto" v-if="filters.length > 0">
        <b-button variant="danger" size="md" @click="clearFilter"><i class="fa fa-times-circle mr-2"></i>{{ $t('general.clearFilter') }}</b-button>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="autoSearchFilters.length > 0">
      <b-col :cols="autoSearchColumnWidth" v-for="(item, index) in autoSearchFilters">
        <!-- Selection (Non API) -->
        <FITvSelect v-if="item.searchParams.options" :label="item.label" v-model="form[item.key]" v-bind="item.searchParams" :width="8">
        </FITvSelect>
        <!-- Selection (API) -->
        <FITAutoSearch v-else :label="item.label" resultKey="ID" @resultKeyOutput="onAutoSearchInputChanged(item.key, $event)" v-bind="item.searchParams" :width="8"></FITAutoSearch>
      </b-col>
      <b-col cols="auto" class="ml-auto">
        <FITSelect v-if="keywordSearchDisabled" :label="$t('general.perPage')" :options="perPage" v-model="pagination.count"></FITSelect>
      </b-col>
      <b-col cols="auto">
        <FITPagination v-if="keywordSearchDisabled" size="md" :totalRows="data.total" :perPage="pagination.count" v-model="pagination.page" @input="onPageChanged"></FITPagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <FITTextInput v-if="!keywordSearchDisabled" :label="$t('general.search')" :width="9" :placeholder="keywordPlaceholder" type="text" v-model="keyword"></FITTextInput>
      </b-col>
      <b-col cols="auto" class="ml-auto">
        <FITSelect :label="$t('general.perPage')" :options="perPage" v-model="pagination.count"></FITSelect>
      </b-col>
      <b-col cols="auto">
        <FITPagination size="md" :totalRows="data.total" :perPage="pagination.count" v-model="pagination.page" @input="onPageChanged"> </FITPagination>
      </b-col>
    </b-row>
    <b-row v-if="hasBatchActionSlot">
      <b-col cols="6">
        <b-button size="sm" variant="link" @click="toggleBatchSelect"><span class="fa pr-2" :class=" { 'fa-check-square': batchSelectEnabled, 'fa-square': !batchSelectEnabled }"></span>{{ $t('general.batchSelect') }}</b-button>
      </b-col>
    </b-row>
    <!-- End of Filter Section -->
    <!-- Start of Batch Action Section-->
    <div class="py-3" v-if="selectedRows.length > 0">
      <slot name="batchAction" :onSuccess="onBatchActionSuccess" :onError="onBatchActionError" :selectedRows="selectedRows"></slot>
    </div>
    <!-- End of Batch Action Section-->
    <!-- Start of Table Section -->
    <!-- Case 1: Table Without Actions Button -->
    <b-table hover responsive striped no-local-sorting :small="small" v-if="actions.length === 0" :sort-by.sync="sorting.orderBy" :sort-desc.sync="isSortedDesc" @sort-changed="onSortChanged" :fields="fields" :items="data.list" @row-clicked="onRowSelected" @row-dblclicked="onRowDoubleClicked" class="pointer-cursor">
      <template slot="selectable" slot-scope="data" v-if="hasBatchActionSlot">
        <b-form-checkbox v-model="selection[`${data.index}`]" name="selectedTableRow" @change="onChecked($event,data)"></b-form-checkbox>
      </template>
      <template v-for="(column, idx) in columns" slot-scope="data" :slot="column.key">
        <span v-html="data.value"></span>
      </template>
    </b-table>
    <!-- Case 2: Table With Actions Button -->
    <b-table v-else responsive hover striped no-local-sorting :small="small" :sort-by.sync="sorting.orderBy" :sort-desc.sync="isSortedDesc" @sort-changed="onSortChanged" :fields="fields" :items="data.list">
      <template slot="selectable" slot-scope="data" v-if="hasBatchActionSlot">
        <b-form-checkbox v-model="selection[`${data.index}`]" name="selectedTableRow" @change="onChecked($event,data)"></b-form-checkbox>
      </template>
      <template v-for="(column, idx) in columns" slot-scope="data" :slot="column.key">
        <span v-html="data.value"></span>
      </template>
      <template slot="action" slot-scope="data">
        <div class="align-middle">
          <FITDropdown :text="actionText != null ? actionText : $t('general.action')" variant="primary" :options="actions" size="md" @clicked="onActionSelected($event, data.item)"></FITDropdown>
        </div>
      </template>
    </b-table>
    <!-- End of Table Section -->
    <b-row align-v="center">
      <b-col cols="6">
        <span class="text-secondary">{{ total }}</span>
      </b-col>
      <b-col cols="auto" class="ml-auto">
        <FITPagination size="md" :totalRows="data.total" :perPage="pagination.count" v-model="pagination.page" @input="onPageChanged"> </FITPagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  FITvSelect,
  FITSelect,
  FITPagination,
  FITTextInput,
  FITDatePicker,
  FITAutoSearch,
  FITCheckbox
} from './Form'

import FITDropdown from './Button/FITDropdown'

import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'FITSearchableTable',
  components: {
    FITvSelect,
    FITSelect,
    FITPagination,
    FITDatePicker,
    FITTextInput,
    FITDropdown,
    FITAutoSearch,
    FITCheckbox
  },

  data() {
    return {
      // Search Lock
      keyword: '',
      searchDelay: -1,
      isSearching: false,

      // selection
      selection: [],
      batchSelectEnabled: false,
      // end of selection
      perPage: [10, 25, 50, 100],
      isSortedDesc: false,
      sorting: {
        orderBy: null,
        direction: null
      },
      pagination: {
        page: 1,
        count: 25
      },
      form: {
        search: null
      },
      data: {
        list: [],
        total: 0
      },
      selectedRows: []
    }
  },

  props: {
    autoSearchFilters: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },

    actionText: {
      type: String,
      default: null
    },

    keywordSearchDisabled: {
      type: Boolean,
      default: false
    },

    keywordPlaceholder: {
      type: String,
      default: ''
    },

    // Selection type
    type: {
      type: String,
      default: null
    },

    // Vuex 
    vuexModule: {
      type: String,
      required: true
    },
    searchAction: {
      type: String,
      required: true
    },
    vuexMutation: {
      type: String,
      default: 'setSelections'
    },

    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray']),

    // Total number of pages
    total() {
      return this.$t('general.pagination.items', {
        page: this.pagination.page,
        total: this.data.total
      })
    },

    // Styles
    autoSearchColumnWidth() {
      return 3
    },

    columnWidth() {
      return 3
    },
    // Parameters for searching
    params() {
      let params = {}
      Object.keys(this.form)
        .forEach((key) => {
          if (this.form[key]) {
            params[key] = this.form[key];
          }
        });

      if (this.sorting.orderBy) {
        params = {
          ...params,
          ...this.sorting
        }
      }
      return params
    },

    // Table columns
    fields() {
      let tmp = this.columns.map((col) => {

        if (col['tdClass']) {
          col['tdClass'].push('align-middle');
        } else {
          col['tdClass'] = ['align-middle'];
        }
        return col;
      });

      // Batch Selection
      if (this.hasBatchActionSlot && this.batchSelectEnabled) {
        tmp.unshift({
          key: 'selectable',
          label: this.$t('general.selectable'),
          thClass: ['text-left', 'align-middle', 'selectable-column'],
          tdClass: ['text-left', 'align-middle', 'selectable-column']
        })
      }

      // Actions 
      if (this.actions.length > 0) {
        let cols = tmp;
        cols.push({
          key: 'action',
          label: this.$t('general.action'),
          thClass: ['action-column', 'text-center'],
          tdClass: ['text-center']
        });
        return cols;
      }
      return tmp;
    },

    hasBatchActionSlot() {
      // https://forum.vuejs.org/t/check-if-components-slot-is-empty/6015/4
      console.debug('slot', this.$scopedSlots);
      if (!this.$scopedSlots) return false;
      return this.$scopedSlots['batchAction'];
    }
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
        this.search(this.pagination);
      }
    },
    pagination: {
      deep: true,
      handler(val) {
        this.search(this.pagination);
      }
    },
    sorting: {
      deep: true,
      handler(val) {
        this.search(this.pagination)
      }
    },

    keyword() {
      //
      if (this.isSearching) return;
      // console.debug('searchDelay', this.searchDelay)
      clearTimeout(this.searchDelay);
      var timeout = setTimeout(() => {
        // console.debug('timeout')
        Vue.set(this.form, 'search', this.keyword)
      }, 500)

      Vue.set(this, 'searchDelay', timeout);
    }
  },

  created() {
    this.filters.forEach((item) =>
      Vue.set(this.form, item.key, item.default)
    )

    Vue.set(this.form, 'search', "");

    this.autoSearchFilters.forEach((item) =>
      Vue.set(this.form, item.key, item.default)
    )

    if (!this.type) {
      return;
    }

    this.$store.dispatch('getAllSelections', this.type)
      .then((json) => {
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          selections: json.data,
          selection: json.data,
        })
      });

    // Selection
    // 
  },

  methods: {
    onChangeInputFilters(val, key, ms) {
      if (this.isSearching) return;
      // console.debug('searchDelay', this.searchDelay)
      clearTimeout(this.searchDelay);
      var timeout = setTimeout(() => {
        // console.debug('timeout')
        Vue.set(this.form, key, val)
      }, ms)

      Vue.set(this, 'searchDelay', timeout);
    },
    getExportPath() {
      return this.params;
    },
    // Batch Action 
    toggleBatchSelect() {
      Vue.set(this, 'batchSelectEnabled', !this.batchSelectEnabled)

      if (!this.batchSelectEnabled) {
        // Reset all selected row if toggling off 
        Vue.set(this, 'selectedRows', this.selectedRows.map((item) => {
          item['_rowVariant'] = '';
          return item;
        }));
        this.resetSelection();
      }
    },

    onBatchActionSuccess(data) {
      Vue.set(this, 'data', {
        list: [],
        total: 0
      });

      this.$emit('events', {
        event: 'onBatchActionSuccess',
        data: data
      })
      this.search(this.pagination);
      this.resetSelection();
    },

    onBatchActionError(data) {
      console.debug('onBatchActionError', data);
      this.$emit('events', {
        event: 'onBatchActionError',
        data: data
      })
    },

    onChecked(evt, data) {

      data.item._rowVariant = (evt) ? 'warning' : ''
      this.$forceUpdate();

      var index = this.selectedRows.map(function(r) { return r.ID; }).indexOf(data.item.ID);
      if (!evt && index !== -1) {
        this.selectedRows.splice(index, 1)
        return
      }

      if (evt) {
        this.selectedRows.push(data.item)
        return
      }

    },

    resetSelection() {
      Vue.set(this, 'selectedRows', []);
      Vue.set(this, 'selection', this.selection.map((checkbox) => false))
    },
    // End of Batch Action

    onSortChanged(val) {
      Vue.set(this.sorting, 'orderBy', val.sortBy)
      Vue.set(this.sorting, 'direction', (val.sortDesc) ? 'asc' : 'desc')
    },

    onPageChanged(newPage) {
      Vue.set(this.pagination, 'page', newPage)
    },

    onAutoSearchInputChanged(key, val) {
      console.debug(key, val);
      Vue.set(this.form, key, val);
    },

    onRowSelected(row) {
      this.$emit('onRowSelected', row);
    },

    onRowDoubleClicked(row) {
      this.$emit('onRowDoubleClicked', row);
    },

    clearFilter() {
      let obj = JSON.parse(JSON.stringify(this.form));
      let emptyForm = {};
      Object.keys(this.form)
        .forEach((key) => {
          let filter = this.filters.filter((item) => {
            return item.key === key;
          });

          if (filter.length > 0 && filter[0].type === 'select' && filter[0].default) { // is selection
            emptyForm[key] = filter[0].default
          } else {
            emptyForm[key] = null;
          }
        });

      Vue.set(this, 'form', emptyForm);
    },

    onActionSelected(key, row) {
      let result = this.actions.filter((item) => {
        return item.key === key;
      });

      if (result.length > 0 && result[0].callback) {
        result[0].callback(key, row, this);
      }
    },

    search(page = {}) {
      if (this.isSearching) {
        return;
      }
      Vue.set(this, 'isSearching', true);
      this.$store.dispatch(`${this.vuexModule}/${this.searchAction}`, {
          ...this.params,
          ...page
        })
        .then((json) => {
          Vue.set(this, 'data', json.data);
          Vue.set(this, 'isSearching', false);
        })
        .catch((err) => {
          console.error(err);
          Vue.set(this, 'isSearching', false);
        })
    }
  }
}

</script>
<style>
.action-column {
  min-width: 150px;
}

.pointer-cursor {
  cursor: pointer
}

.selectable-column {
  max-width: 70px;
}

</style>



// WEBPACK FOOTER //
// src/components/FITSearchableTable.vue